import Hero from "@/components/ui/Hero";
import EstimateForm from "@/components/forms/EstimateForm";
import CTABlock from "@/components/ui/CTABlock";
import { PHASE3_BRAND_VOICE } from "@/lib/constants";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function StormDamage() {
    useDocumentTitle(
        "Storm Damage Pool Cage & Screen Repair · Naples FL · A1 Screening",
        "Storm-damaged pool cage and screen repair in Naples and Southwest Florida. Free estimates. Storm repair availability may vary by schedule and season."
    );
    return (
        <>
            <Hero
                eyebrow="Storm Damage"
                title="Storm Damage Pool Cage & Screen Repair"
                subtitle="After the storm, your pool cage shouldn't wait. We'll come look — for free."
                primaryCta={{ to: "#storm-form", label: "Request Storm Damage Repair" }}
            />
            <section className="a1-section a1-bg-alt">
                <div className="a1-container max-w-3xl">
                    <p className="text-[var(--color-text-muted)] mb-4">
                        We repair storm-damaged pool cages and screens across Naples and Southwest Florida — torn screens, bent frames, broken hardware, and full-cage damage.
                    </p>
                    <p className="text-[var(--color-text)] font-semibold mb-1">{PHASE3_BRAND_VOICE.cautious_storm}</p>
                    <p className="text-[var(--color-text-muted)]">Call us early so we can get you on the schedule.</p>
                </div>
            </section>

            <section className="a1-section" id="storm-form">
                <div className="a1-container max-w-2xl">
                    <h2 className="mb-3">Tell Us About the Storm Damage</h2>
                    <EstimateForm variant="long" presetService="storm" source="/storm-damage" />
                </div>
            </section>

            <CTABlock />
        </>
    );
}
